module.exports = __webpack_public_path__ + "assets/img/han.fcc46e0c.png";